import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class DigestAPICall extends APICallV4 {
    _method = 'private/digest';
    _type: Method = 'get';
}
